import { useState } from 'react'
import axios from 'axios'
import { Modal, message } from 'antd'
import MyInput from '../../components/forms/input'
import MyRichText from '../../components/forms/richText'
import MyRadio from '../../components/forms/radio'

const SendNotice = (props) => {
  const [formValue, setFormValue] = useState({})
  const [errorMsg, setErrorMsg] = useState({})

  const handleOk = () => {
    setErrorMsg({})
    if (!formValue.title) {
      setErrorMsg({titleEmpty: '标题不能为空'})
      return false
    }

    axios.post('/admin/notice/send', { 
      title: formValue.title,
      notice_crowd: formValue.notice_crowd,
      content: formValue.content
    })
      .then(function (response) {
        if (response.errcode === 0) {
          handleCancel()
          props.getNoticeData()
          message.success('发送成功！')
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleCancel = () => {
    setErrorMsg({})
    setFormValue({})
    props.isCancel()
  }

  return (
    <Modal
      destroyOnClose={true}
      title="发送通知"
      width='800px'
      open={props.isOpen}
      maskClosable={false}
      onOk={handleOk}
      onCancel={handleCancel}
      cancelText="取消"
      okText="发送">
      
      <MyInput
        id="title"
        required
        autoFocus
        maxLength={64}
        label='通知标题'
        placeholder='请输入通知标题'
        value={formValue.title}
        onChange={setFormValue}
        errorMsg={errorMsg.titleEmpty}
      />

      <MyRadio
        id='notice_crowd'
        label='通知人群'
        options={[
          {
            label: '全部用户',
            value: 1,
          },
          {
            label: '会员用户',
            value: 2,
          },
          {
            label: '普通用户',
            value: 3,
          }
        ]}
        defaultValue={1}
        value={formValue.notice_crowd}
        onChange={setFormValue}
      />

      <MyRichText
        id='content'
        value={formValue.content}
        setValue={setFormValue}
      />
    </Modal>
  )
}

export default SendNotice
